import { ComplexEnumItem } from '../../utils/complexEnum/ComplexEnumItem'

export class DailyItem<
  ID extends Lowercase<string>,
  Name extends string,
  Label extends string,
  Value extends number
> extends ComplexEnumItem<ID> {
  readonly label: Label
  readonly name: Name
  readonly value: Value
  constructor({
    id,
    label,
    name,
    value,
  }: Pick<
    DailyItem<ID, Name, Label, Value>,
    'id' | 'name' | 'label' | 'value'
  >) {
    super(id)
    this.label = label
    this.name = name
    this.value = value
  }
}
